import consola from 'consola'
const logger = consola.withScope('nuxt:typo3')
export default logger
